import React from "react";
// import { AiOutlineArrowUp, AiOutlineArrowDown } from "react-icons/ai";
import { BsFillCaretUpFill, BsFillCaretDownFill } from "react-icons/bs";
import { FaTrashAlt } from "react-icons/fa";
import $ from "jquery";

$(function () {
  $('[data-toggle="tooltip"]').tooltip();
});

export default function CompletedStocks({ list, deleteStock }) {
  return (
    <>
      {list.completed && (
        <tr key={list.id}>
          <td>{list.company}</td>
          <td>{list.date}</td>
          <td>{list.peroid}</td>
          <td>{list.quantity}</td>
          <td>{(+list.price + list.totalFees / list.quantity).toFixed(2)}</td>
          <td>{list.avgPrice.toFixed(2)}</td>
          <td>{list.allFees.toFixed(2)}</td>
          <td>{list.totalCosts.toFixed(2)}</td>
          <td
            className={
              "d-flex align-items-center justify-content-around " +
              (list.totalProfits <= 0 ? "text-danger" : "text-success")
            }
          >
            {list.totalProfits.toFixed(2)}{" "}
            {(list.totalProfits > 0 && <BsFillCaretUpFill />) ||
              (list.totalProfits < 0 && <BsFillCaretDownFill />)}
            {list.percentage.toFixed(2)}
            &rlm;{"%"}
          </td>
          <td
            data-toggle="tooltip"
            data-placement="bottom"
            title={`الاجمالي: ${(
              list.net +
              list.allFees -
              list.totalFees
            ).toFixed(2)}`}
          >
            {list.net.toFixed(2)}
          </td>
          <td>
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              data-toggle="tooltip"
              data-placement="bottom"
              title="حذف"
              onClick={() => {
                $("button").tooltip("hide");
                deleteStock(list.id);
              }}
            >
              <FaTrashAlt size="1.4em" />
            </button>
          </td>
        </tr>
      )}
    </>
  );
}
